import type { FC } from 'react';
import React from 'react';
import {
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  type TooltipProps,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface MangopaySingleReceiptAmountLabelTooltipProps
  extends Omit<TooltipProps, 'title'> {
  hasPendingTransfer: boolean;
}

export const MangopaySingleReceiptAmountLabelTooltip: FC<
  MangopaySingleReceiptAmountLabelTooltipProps
> = ({ hasPendingTransfer, children, ...props }) => {
  const { t } = useTranslation();

  return (
    <CustomTooltip
      {...props}
      title={
        <Stack gap={0.5} px={0.5} py={0.5}>
          <Typography color="inherit" variant="subtitle1">
            {t('receipts.batch.payment.pending-payment')}
          </Typography>
          <Stack>
            <Typography color="inherit" variant="subtitle2">
              {t('receipts.batch.reason-low-balance')}
            </Typography>
            {hasPendingTransfer && (
              <Typography variant="subtitle2">
                {t('receipts.batch.resolution-transfer-in-progress')}
              </Typography>
            )}
          </Stack>
        </Stack>
      }
      placement="bottom"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}
    >
      <div>{children}</div>
    </CustomTooltip>
  );
};

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.warning.lighter,
    color: theme.palette.warning.darker,
    minWidth: 500,
  },
}));
